angular.module('impactx.product').controller('PriceListCtrl', ['$scope', '$locale', PriceListCtrl]);

function PriceListCtrl($scope, $locale)
{

    var ctrl = this;
    $scope.priceCopy = [];
    this.addPriceListItem = function(priceList)
    {
        var i = priceList.length - 1;
        while (i > 0)
        {
            if (!priceList[i].deleted)
            {
                break;
            }
            i--;
        }

        var priceListItemCopy = JSON.parse(JSON.stringify(priceList[i]));
        priceListItemCopy.id = 0;
        priceList.push(priceListItemCopy);
    };

    this.removePriceListItem = function(priceListItem)
    {
        priceListItem.deleted = true;
    };

    $scope.$watch(function () {
            return $scope.orderUnit;
        },
        function (newValue, oldValue)
        {
            if (newValue != oldValue)
            {
                ctrl.updatePriceLabel($scope.priceList);
            }
        });

    $scope.getMaxPriceDigits = function () {
        var maxFracPrice = null;
        if ($scope.isDerived || $scope.useDerivedMaxPriceDigits)
        {
            if ($scope.priceList.oUPriceAmount.value > 1 || $scope.useMaxPriceDigitsForAllDerived)
            {
                maxFracPrice = $scope.maxPriceDigitsForDerived;
            }
            else
            {
                maxFracPrice = 2;
            }
        }
        else if ($scope.useMaxPriceDigits)
        {
            maxFracPrice = $scope.maxPriceDigits;
        }
        return maxFracPrice;
    };

    this.updatePriceLabel = function(priceList)
    {
        var orderUnit = $scope.orderUnit;
        if (!orderUnit)
        {
            orderUnit = "";
        }
        var negative = false;

        var data = (priceList.priceListItems[0].value.value *
            ($scope.priceFactor !== null && $scope.priceFactor !== undefined ? $scope.priceFactor : 1)
            + ($scope.priceOffset !== null && $scope.priceOffset !== undefined ? $scope.priceOffset : 0)
        );
        if (data < 0)
        {
            data = -1 * data;
            negative = true;
        }
        var maxFracPrice = $scope.getMaxPriceDigits();
        if (!maxFracPrice)
        {
            maxFracPrice = 11 - Math.floor(Math.log(data) / Math.log(10));
        }
        var patternPrice =
        {
            "gSize": 3,
            "lgSize": 3,
            "maxFrac": maxFracPrice,
            "minFrac": 2,
            "negPre": "-",
            "negSuf": "",
            "posPre": "",
            "posSuf": " " + priceList.currency.value
        };

        var maxFracMinValue = 11 - Math.floor(Math.log(priceList.priceListItems[0].minValue.value) / Math.log(10));
        var patternMinValue =
        {
            "gSize": 3,
            "lgSize": 3,
            "maxFrac": maxFracMinValue,
            "minFrac": 0,
            "negPre": "-",
            "negSuf": "",
            "posPre": $scope.fromLabel + " ",
            "posSuf": " " +  orderUnit + ": "
        };

        var maxFracEachValue = 11 - Math.floor(Math.log(priceList.oUPriceAmount.value) / Math.log(10));
        var patternEachValue =
        {
            "gSize": 3,
            "lgSize": 3,
            "maxFrac": maxFracEachValue,
            "minFrac": 0,
            "negPre": "-",
            "negSuf": "",
            "posPre": $scope.eachLabel + " ",
            "posSuf": " " +  orderUnit
        };
        var formatedPrice = formatNumber(Math.round(data * Math.pow(10, maxFracPrice + 2)) / Math.pow(10, maxFracPrice + 4) ,
            patternPrice,  $locale.NUMBER_FORMATS.GROUP_SEP,  $locale.NUMBER_FORMATS.DECIMAL_SEP, undefined);
        var formattedMinValue = formatNumber(priceList.priceListItems[0].minValue.value,
            patternMinValue,  $locale.NUMBER_FORMATS.GROUP_SEP,  $locale.NUMBER_FORMATS.DECIMAL_SEP, undefined);
        var formattedEachValue = formatNumber(priceList.oUPriceAmount.value,
            patternEachValue,  $locale.NUMBER_FORMATS.GROUP_SEP,  $locale.NUMBER_FORMATS.DECIMAL_SEP, undefined);

        $scope.hiddenLabel = formattedMinValue + " " + (negative ? "-" : "") + formatedPrice + " " + formattedEachValue;
    };

    this.updatePriceLabel($scope.priceList);

    this.toggleShown = function(priceList)
    {
        priceList.shown = !priceList.shown;
    };

    $scope.$watch(function () {
            return $scope.priceList.shown;
        },
        function (newValue, oldValue)
        {
            if (!newValue)
            {
                ctrl.updatePriceLabel($scope.priceList);
            }
        });


    this.deletePriceList = function(priceList)
    {
        for (var i = 0; i < priceList.priceListItems.length; i++)
        {
            priceList.priceListItems[i].deleted = true;
        }
        priceList.deleted = true;
    };

    $scope.getPriceCopy = function(index, priceListItem)
    {
        if (!$scope.priceCopy[index])
        {
            $scope.priceCopy[index] = {label: "", value: priceListItem.value.value, showMust: true};
            $scope.$watch(function () {
                    return priceListItem.value.value;
                },
                function (newValue, oldValue)
                {
                    if(newValue != oldValue)
                    {
                        $scope.priceCopy[index].value = newValue;
                    }
                }
            );
        }

        return $scope.priceCopy[index];
    };

}